import { Steps, Row, Col, message } from "antd";
import React, { useState, useEffect } from "react";
import Heading from "../../components/Heading";
import BasicDetails from "./BasicDetails";
import NewRateCard from "./NewRateCard";
import AggreementDetails from "./AggreementDetails";
import DefaultCompany from "./DefaultCompany";
import DocumentDetails from "./DocumentDetails";

import { useLocation } from "react-router-dom";
import { customerOnboardingAPI } from "../../api/LeadApi";
import BrandingDetails from "./BrandingDetails";

const CPLeadList = () => {
  const history = useLocation();
  const [current, setCurrent] = useState(0);
  const [getData, setGetData] = useState(null);
  const [headingTitle, setHeadingTitle] = useState(null);
  const [cpPinCode, setCpPinCode] = useState(null);

  useEffect(() => {
    if (history?.state?.step) {
      setCurrent(history?.state?.step);
    }
  }, [history?.state]);

  useEffect(() => {
    const customerId = localStorage.getItem("customerId");
    if (customerId) {
      getCPDetails_(customerId);
    }
    window.scrollTo(0, 0);
    if (window.location.pathname.includes("onboarding")) {
      setHeadingTitle("CP onboarding");
    } else {
      setHeadingTitle("CP Lead Generation");
    }
  }, [current]);

  // useEffect(() => {
  //   if (history.state !== null) {
  //     setCurrent(history.state);
  //   }
  // }, []);

  const getCPDetails_ = async (id) => {
    const response = await customerOnboardingAPI.getLeadById(id);
    if (response?.status) {
      let data = response?.response?.data;
      setGetData(data);
    } else {
      message.error("Network error");
    }
  };

  const patchClient = async (values, checkBtn) => {
    const id = localStorage.getItem("customerId");

    let response = await customerOnboardingAPI.patchLead(id, values);
    if (response?.status) {
      message.success("CP updated successfully.");
      if (checkBtn) {
        setCurrent(current + 1);
      }
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const handleStepsChange = () => {
    setCurrent(current + 1);
  };

  const goBackStep = () => {
    window.scrollTo(0, 0);
    setCurrent(current - 1);
  };

  return (
    <div className="p-2">
      <Heading title={headingTitle} />
      <div className="">
        <div className="master-main-container">
          <Row>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ padding: "10px 15px 0 15px" }}
              className="global-steps-container lead-cp-onboard"
            >
              <Steps
                current={current}
                direction="horizontal"
                onChange={onChange}
                className="cp-steps"
                items={[
                  {
                    title: "Basic Details",
                    description: "Provide your basic details",
                  },
                  {
                    title: "Company Details",
                    description: "Provide company details",
                  },
                  {
                    title: "Quotation",
                    description: "Provide rate card details",
                  },

                  {
                    title: "Agreement Details",
                    description: "Provide aggrement details",
                  },
                  {
                    title: "Document Details",
                    description: "Provide document details",
                  },
                  {
                    title: "Branding Details",
                    description: "Provide branding details",
                  },
                ]}
              />
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              {current === 0 ? (
                <BasicDetails
                  handleStepsChange={handleStepsChange}
                  patchClient={patchClient}
                  getData={getData}
                  setCpPinCodeData={(val) => setCpPinCode(val)}
                />
              ) : current === 1 ? (
                <DefaultCompany
                  handleStepsChange={handleStepsChange}
                  getData={getData}
                  goBackStep={goBackStep}
                />
              ) : current === 2 ? (
                <NewRateCard
                  handleStepsChange={handleStepsChange}
                  getData={getData}
                  cpPinCodeData={cpPinCode}
                  goBackStep={goBackStep}
                  userType={"CP"}
                />
              ) : current === 3 ? (
                <AggreementDetails
                  handleStepsChange={handleStepsChange}
                  goBackStep={goBackStep}
                  getData={getData}
                  userType={"CP"}
                />
              ) : current === 4 ? (
                <DocumentDetails
                  handleStepsChange={handleStepsChange}
                  goBackStep={goBackStep}
                  getData={getData}
                  userType={"CP"}
                />
              ) : current === 5 ? (
                <BrandingDetails
                  handleStepsChange={handleStepsChange}
                  goBackStep={goBackStep}
                  getData={getData}
                  userType={"CP"}
                />
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default CPLeadList;
